import _classCallCheck from "/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _toConsumableArray from "/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

var _browserStyleMap2;

/**
 * Isomorphic logging module with support for colors!
 *
 * @module logging
 */
import * as env from './environment.js';
import * as set from './set.js';
import * as pair from './pair.js';
import * as dom from './dom.js';
import * as json from './json.js';
import * as map from './map.js';
import * as eventloop from './eventloop.js';
import * as math from './math.js';
import * as common from './logging.common.js';
export { BOLD, UNBOLD, BLUE, GREY, GREEN, RED, PURPLE, ORANGE, UNCOLOR } from './logging.common.js';
/**
 * @type {Object<Symbol,pair.Pair<string,string>>}
 */

var _browserStyleMap = (_browserStyleMap2 = {}, _defineProperty(_browserStyleMap2, common.BOLD, pair.create('font-weight', 'bold')), _defineProperty(_browserStyleMap2, common.UNBOLD, pair.create('font-weight', 'normal')), _defineProperty(_browserStyleMap2, common.BLUE, pair.create('color', 'blue')), _defineProperty(_browserStyleMap2, common.GREEN, pair.create('color', 'green')), _defineProperty(_browserStyleMap2, common.GREY, pair.create('color', 'grey')), _defineProperty(_browserStyleMap2, common.RED, pair.create('color', 'red')), _defineProperty(_browserStyleMap2, common.PURPLE, pair.create('color', 'purple')), _defineProperty(_browserStyleMap2, common.ORANGE, pair.create('color', 'orange')), _defineProperty(_browserStyleMap2, common.UNCOLOR, pair.create('color', 'black')), _browserStyleMap2);
/**
 * @param {Array<string|Symbol|Object|number>} args
 * @return {Array<string|object|number>}
 */

/* c8 ignore start */


var computeBrowserLoggingArgs = function computeBrowserLoggingArgs(args) {
  var strBuilder = [];
  var styles = [];
  var currentStyle = map.create();
  /**
   * @type {Array<string|Object|number>}
   */

  var logArgs = []; // try with formatting until we find something unsupported

  var i = 0;

  for (; i < args.length; i++) {
    var arg = args[i]; // @ts-ignore

    var style = _browserStyleMap[arg];

    if (style !== undefined) {
      currentStyle.set(style.left, style.right);
    } else {
      if (arg.constructor === String || arg.constructor === Number) {
        var _style = dom.mapToStyleString(currentStyle);

        if (i > 0 || _style.length > 0) {
          strBuilder.push('%c' + arg);
          styles.push(_style);
        } else {
          strBuilder.push(arg);
        }
      } else {
        break;
      }
    }
  }

  if (i > 0) {
    // create logArgs with what we have so far
    logArgs = styles;
    logArgs.unshift(strBuilder.join(''));
  } // append the rest


  for (; i < args.length; i++) {
    var _arg = args[i];

    if (!(_arg instanceof Symbol)) {
      logArgs.push(_arg);
    }
  }

  return logArgs;
};
/* c8 ignore stop */

/* c8 ignore start */


var computeLoggingArgs = env.supportsColor ? computeBrowserLoggingArgs : common.computeNoColorLoggingArgs;
/* c8 ignore stop */

/**
 * @param {Array<string|Symbol|Object|number>} args
 */

export var print = function print() {
  var _console;

  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  (_console = console).log.apply(_console, _toConsumableArray(computeLoggingArgs(args)));
  /* c8 ignore next */


  vconsoles.forEach(function (vc) {
    return vc.print(args);
  });
};
/* c8 ignore start */

/**
 * @param {Array<string|Symbol|Object|number>} args
 */

export var warn = function warn() {
  var _console2;

  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  (_console2 = console).warn.apply(_console2, _toConsumableArray(computeLoggingArgs(args)));

  args.unshift(common.ORANGE);
  vconsoles.forEach(function (vc) {
    return vc.print(args);
  });
};
/* c8 ignore stop */

/**
 * @param {Error} err
 */

/* c8 ignore start */

export var printError = function printError(err) {
  console.error(err);
  vconsoles.forEach(function (vc) {
    return vc.printError(err);
  });
};
/* c8 ignore stop */

/**
 * @param {string} url image location
 * @param {number} height height of the image in pixel
 */

/* c8 ignore start */

export var printImg = function printImg(url, height) {
  if (env.isBrowser) {
    console.log('%c                      ', "font-size: ".concat(height, "px; background-size: contain; background-repeat: no-repeat; background-image: url(").concat(url, ")")); // console.log('%c                ', `font-size: ${height}x; background: url(${url}) no-repeat;`)
  }

  vconsoles.forEach(function (vc) {
    return vc.printImg(url, height);
  });
};
/* c8 ignore stop */

/**
 * @param {string} base64
 * @param {number} height
 */

/* c8 ignore next 2 */

export var printImgBase64 = function printImgBase64(base64, height) {
  return printImg("data:image/gif;base64,".concat(base64), height);
};
/**
 * @param {Array<string|Symbol|Object|number>} args
 */

export var group = function group() {
  var _console3;

  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }

  (_console3 = console).group.apply(_console3, _toConsumableArray(computeLoggingArgs(args)));
  /* c8 ignore next */


  vconsoles.forEach(function (vc) {
    return vc.group(args);
  });
};
/**
 * @param {Array<string|Symbol|Object|number>} args
 */

export var groupCollapsed = function groupCollapsed() {
  var _console4;

  for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    args[_key4] = arguments[_key4];
  }

  (_console4 = console).groupCollapsed.apply(_console4, _toConsumableArray(computeLoggingArgs(args)));
  /* c8 ignore next */


  vconsoles.forEach(function (vc) {
    return vc.groupCollapsed(args);
  });
};
export var groupEnd = function groupEnd() {
  console.groupEnd();
  /* c8 ignore next */

  vconsoles.forEach(function (vc) {
    return vc.groupEnd();
  });
};
/**
 * @param {function():Node} createNode
 */

/* c8 ignore next 2 */

export var printDom = function printDom(createNode) {
  return vconsoles.forEach(function (vc) {
    return vc.printDom(createNode());
  });
};
/**
 * @param {HTMLCanvasElement} canvas
 * @param {number} height
 */

/* c8 ignore next 2 */

export var printCanvas = function printCanvas(canvas, height) {
  return printImg(canvas.toDataURL(), height);
};
export var vconsoles = set.create();
/**
 * @param {Array<string|Symbol|Object|number>} args
 * @return {Array<Element>}
 */

/* c8 ignore start */

var _computeLineSpans = function _computeLineSpans(args) {
  var spans = [];
  var currentStyle = new Map(); // try with formatting until we find something unsupported

  var i = 0;

  for (; i < args.length; i++) {
    var arg = args[i]; // @ts-ignore

    var style = _browserStyleMap[arg];

    if (style !== undefined) {
      currentStyle.set(style.left, style.right);
    } else {
      if (arg.constructor === String || arg.constructor === Number) {
        // @ts-ignore
        var span = dom.element('span', [pair.create('style', dom.mapToStyleString(currentStyle))], [dom.text(arg.toString())]);

        if (span.innerHTML === '') {
          span.innerHTML = '&nbsp;';
        }

        spans.push(span);
      } else {
        break;
      }
    }
  } // append the rest


  for (; i < args.length; i++) {
    var content = args[i];

    if (!(content instanceof Symbol)) {
      if (content.constructor !== String && content.constructor !== Number) {
        content = ' ' + json.stringify(content) + ' ';
      }

      spans.push(dom.element('span', [], [dom.text(
      /** @type {string} */
      content)]));
    }
  }

  return spans;
};
/* c8 ignore stop */


var lineStyle = 'font-family:monospace;border-bottom:1px solid #e2e2e2;padding:2px;';
/* c8 ignore start */

export var VConsole =
/*#__PURE__*/
function () {
  /**
   * @param {Element} dom
   */
  function VConsole(dom) {
    _classCallCheck(this, VConsole);

    this.dom = dom;
    /**
     * @type {Element}
     */

    this.ccontainer = this.dom;
    this.depth = 0;
    vconsoles.add(this);
  }
  /**
   * @param {Array<string|Symbol|Object|number>} args
   * @param {boolean} collapsed
   */


  _createClass(VConsole, [{
    key: "group",
    value: function group(args) {
      var _this = this;

      var collapsed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      eventloop.enqueue(function () {
        var triangleDown = dom.element('span', [pair.create('hidden', collapsed), pair.create('style', 'color:grey;font-size:120%;')], [dom.text('▼')]);
        var triangleRight = dom.element('span', [pair.create('hidden', !collapsed), pair.create('style', 'color:grey;font-size:125%;')], [dom.text('▶')]);
        var content = dom.element('div', [pair.create('style', "".concat(lineStyle, ";padding-left:").concat(_this.depth * 10, "px"))], [triangleDown, triangleRight, dom.text(' ')].concat(_computeLineSpans(args)));
        var nextContainer = dom.element('div', [pair.create('hidden', collapsed)]);
        var nextLine = dom.element('div', [], [content, nextContainer]);
        dom.append(_this.ccontainer, [nextLine]);
        _this.ccontainer = nextContainer;
        _this.depth++; // when header is clicked, collapse/uncollapse container

        dom.addEventListener(content, 'click', function (_event) {
          nextContainer.toggleAttribute('hidden');
          triangleDown.toggleAttribute('hidden');
          triangleRight.toggleAttribute('hidden');
        });
      });
    }
    /**
     * @param {Array<string|Symbol|Object|number>} args
     */

  }, {
    key: "groupCollapsed",
    value: function groupCollapsed(args) {
      this.group(args, true);
    }
  }, {
    key: "groupEnd",
    value: function groupEnd() {
      var _this2 = this;

      eventloop.enqueue(function () {
        if (_this2.depth > 0) {
          _this2.depth--; // @ts-ignore

          _this2.ccontainer = _this2.ccontainer.parentElement.parentElement;
        }
      });
    }
    /**
     * @param {Array<string|Symbol|Object|number>} args
     */

  }, {
    key: "print",
    value: function print(args) {
      var _this3 = this;

      eventloop.enqueue(function () {
        dom.append(_this3.ccontainer, [dom.element('div', [pair.create('style', "".concat(lineStyle, ";padding-left:").concat(_this3.depth * 10, "px"))], _computeLineSpans(args))]);
      });
    }
    /**
     * @param {Error} err
     */

  }, {
    key: "printError",
    value: function printError(err) {
      this.print([common.RED, common.BOLD, err.toString()]);
    }
    /**
     * @param {string} url
     * @param {number} height
     */

  }, {
    key: "printImg",
    value: function printImg(url, height) {
      var _this4 = this;

      eventloop.enqueue(function () {
        dom.append(_this4.ccontainer, [dom.element('img', [pair.create('src', url), pair.create('height', "".concat(math.round(height * 1.5), "px"))])]);
      });
    }
    /**
     * @param {Node} node
     */

  }, {
    key: "printDom",
    value: function printDom(node) {
      var _this5 = this;

      eventloop.enqueue(function () {
        dom.append(_this5.ccontainer, [node]);
      });
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _this6 = this;

      eventloop.enqueue(function () {
        vconsoles.delete(_this6);
      });
    }
  }]);

  return VConsole;
}();
/* c8 ignore stop */

/**
 * @param {Element} dom
 */

/* c8 ignore next */

export var createVConsole = function createVConsole(dom) {
  return new VConsole(dom);
};
/**
 * @param {string} moduleName
 * @return {function(...any):void}
 */

export var createModuleLogger = function createModuleLogger(moduleName) {
  return common.createModuleLogger(print, moduleName);
};